module.exports = __webpack_public_path__ + "static/img/2_1.39956d1a.jpg";